module.exports = __webpack_public_path__ + "static/img/新闻动态1.09e68dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/新闻动态1.png
// module id = HxyG
// module chunks = 1